import { makeHttpRequest } from "@/shared";

export const deleteContract = async (id) => {
    await makeHttpRequest({
        url: `order/${id}`,
        method: "DELETE",
    });
};
